import React, { useEffect, useState } from 'react';
import { InputProp } from '../../utils/tsConfig';

const Text: React.FC<InputProp> = (props) => {
	const { keyId, setState, state, isArray, indexVal, arrayName, max, min, className, returnKey, fieldName, onChange, required = false, disabled = false } = props;
	const [selected, setSelected] = useState('');

	const onChangeValue = (e: any) => {
		if (isArray) {
			if (arrayName && indexVal !== undefined && returnKey && setState) {
				if (state?.[arrayName] && state?.[arrayName]?.[indexVal] && state[arrayName]?.[indexVal]?.[returnKey]) {
					const updatedState = { ...state };
					updatedState[arrayName][indexVal][returnKey] = e.target.value;
					setState(updatedState);
					setSelected(e.target.value || '');
				} else {
					const updatedState = { ...state };
					if (!updatedState?.[arrayName]) {
						updatedState[arrayName] = [];
					}
					while (updatedState?.[arrayName]?.length <= indexVal) {
						updatedState[arrayName].push({});
					}
					if (typeof updatedState?.[arrayName]?.[indexVal] !== 'object' || updatedState?.[arrayName]?.[indexVal] === null) {
						updatedState[arrayName][indexVal] = {};
					}
					updatedState[arrayName][indexVal][returnKey] = e.target.value;
					setState(updatedState);
					setSelected(e.target.value || '');
				}
			} else if (arrayName && indexVal !== undefined && setState) {
				if (state?.[arrayName] && state?.[arrayName]?.[indexVal]) {
					const updatedState = { ...state };
					updatedState[arrayName][indexVal] = e.target.value;
					setState(updatedState);
					setSelected(e.target.value || '');
				} else {
					const updatedState = { ...state };
					if (!updatedState?.[arrayName]) {
						updatedState[arrayName] = [];
					}
					while (updatedState?.[arrayName]?.length <= indexVal) {
						updatedState[arrayName].push('');
					}
					updatedState[arrayName][indexVal] = e.target.value;
					setState(updatedState);
					setSelected(e.target.value || '');
				}
			}
		} else {
			if (onChange) {
				onChange({ value: e.target.value });
				setSelected(e.target.value);
			}
			if (setState) {
				if (returnKey) {
					setState({ ...state, [returnKey]: e.target.value });
				} else {
					setState(e.target.value);
				}
			}
		}
	};

	useEffect(() => {
		if (isArray) {
			if (arrayName && indexVal !== undefined && returnKey) {
				if (state?.[arrayName] && state?.[arrayName]?.[indexVal] && state?.[arrayName]?.[indexVal]?.[returnKey]) {
					setSelected(state?.[arrayName]?.[indexVal]?.[returnKey]);
				}
			} else if (arrayName && indexVal !== undefined) {
				if (state?.[arrayName] && state?.[arrayName]?.[indexVal]) {
					setSelected(state?.[arrayName]?.[indexVal]);
				}
			}
		} else {
			if (returnKey) {
				setSelected(state?.[returnKey?.toString()] || '');
			} else {
				setSelected(state);
			}
		}
	}, [returnKey, state, isArray, arrayName, indexVal]);

	// Safe fieldName handling
	const safeFieldName = fieldName || '';
	const displayName = safeFieldName.replace(/\*$/, '');
	const isRequired = safeFieldName.endsWith('*');

	return (
		<label key={keyId} className={`customInput ${className} dark:bg-[#202020f5] dark:border-0`}>
			<input 
				value={selected || ''} 
				required={required} 
				maxLength={max} 
				minLength={min} 
				disabled={disabled} 
				className='input__field outline-none border rounded-md lg:text-sm xl:text-md lg:text-left md:text-center dark:bg-[#202020f5] dark:border-0 dark:text-[#ffffffcb]' 
				onChange={onChangeValue} 
				type={'text'} 
				placeholder=' ' 
			/>
			<span className='input__label dark:bg-[#202020f5] dark:border-0 dark:text-[#ffffffcb]'>
				{displayName}
				{isRequired && <span className='mandatory-asterisk'>*</span>}
			</span>
		</label>
	);
};

export default Text;